var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75893 0.226365C10.0803 0.526894 10.0803 1.01832 9.75893 1.32014L3.92932 6.77304C3.76865 6.92395 3.55856 7.00003 3.34708 7.00003C3.13697 7.00003 2.92682 6.92395 2.76614 6.77304L0.24204 4.42346C-0.0806801 4.12293 -0.0806801 3.63151 0.24204 3.32969C0.563385 3.02787 1.08387 3.02787 1.40522 3.32969L3.34708 5.13108L8.5944 0.226365C8.91574 -0.0754549 9.43621 -0.0754549 9.75893 0.226365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/checkWhite.6de9c9a9.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75893 0.226365C10.0803 0.526894 10.0803 1.01832 9.75893 1.32014L3.92932 6.77304C3.76865 6.92395 3.55856 7.00003 3.34708 7.00003C3.13697 7.00003 2.92682 6.92395 2.76614 6.77304L0.24204 4.42346C-0.0806801 4.12293 -0.0806801 3.63151 0.24204 3.32969C0.563385 3.02787 1.08387 3.02787 1.40522 3.32969L3.34708 5.13108L8.5944 0.226365C8.91574 -0.0754549 9.43621 -0.0754549 9.75893 0.226365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/checkWhite.6de9c9a9.svg";
export { ForwardRef as ReactComponent };